import React, { memo, ReactElement } from "react";
import { OfferBannerV4 } from "./v4";
interface OfferBannerProps {
    offerCode: string;
    offerHeaderText?: string;
}
function OfferBanner(props: OfferBannerProps): ReactElement {
    return <OfferBannerV4 {...props} />;
}

export default memo(OfferBanner);
